import styled from 'styled-components';

const Loader = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export default Loader;
